import axios from "axios";

export const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d.msg || String(d);
}

export const logEvent = (action, details = "", entity = "", entity_id = "") =>
  api.post("/audit/event", { action, details, entity, entity_id }).catch(() => {});

export const gbp = (v) =>
  new Intl.NumberFormat("en-GB", { style: "currency", currency: "GBP", maximumFractionDigits: 0 }).format(v || 0);

export const num = (v) => new Intl.NumberFormat("en-GB").format(Math.round(v || 0));

export const dt = (iso) =>
  iso ? new Date(iso).toLocaleString("en-GB", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit", second: "2-digit" }) : "—";

export const YEARS = ["2022", "2023", "2024", "2025", "2026"];

export const ROLE_LABEL = { manager: "Manager", purfleet_manager: "Purfleet Manager", user: "User" };
